import styled from "styled-components";

export const Container = styled.div`
    .document {
        width: 50%;
        margin-bottom: 2rem !important;
        cursor: pointer;
    }
`;
